export enum ActivityType {
  Comment = "Comment",
  OrderPlay = "OrderPlay",
  OrderRun = "OrderRun",
  OrderRetry = "OrderRetry",
  OrderRetryScratch = "OrderRetryScratch",
  OrderCancel = "OrderCancel",
  OrderFailed = "OrderFailed",
  OrderCompleted = "OrderCompleted",
  OrderResume = "OrderResume",
  OrderModify = "OrderModify",
  OrderFollowerChanged = "OrderFollowerChanged",
  OrderPriorityChanged = "OrderPriorityChanged",
  OrderIssue = "OrderIssue",
  AssetCreate = "AssetCreate",
  AssetModify = "AssetModify",
  AssetMetadataChange = "AssetMetadataChange",
  AssetVisit = "AssetVisit",
  AssetPermissionChange = "AssetPermissionChange",
  AssetStatusChange = "AssetStatusChange",
  AssetClassChange = "AssetClassChange",
  AssetDisable = "AssetDisable",
  AssetMove = "AssetMove",
  AssetSearch = "AssetSearch",
  AssetPlay = "AssetPlay",
  AssetFollowerChange = "AssetFollowerChange",
  AssetProviderChange = "AssetProviderChange",
  AssetDelete = "AssetDelete",
  AssetFileUpload = "AssetFileUpload",
  AssetFileDelete = "AssetFileDelete",
  AssetShareCreate = "AssetShareCreate",
  AssetShareDelete = "AssetShareDelete",
  AssetShareCancel = "AssetShareCancel",
  AssetShareModify = "AssetShareModify",
  AssetShareClipImport = "AssetShareClipImport",
  AssetClipCreate = "AssetClipCreate",
  AssetClipDelete = "AssetClipDelete",
  AssetCopy = "AssetCopy",
  AssetReject = "AssetReject",
  SpeechToTextRequest = "SpeechToTextRequest",
  SpeechToTextReceive = "SpeechToTextReceive",
  ApprovalRequest = "ApprovalRequest",
  ApprovalAccept = "ApprovalAccept",
  ApprovalDecline = "ApprovalDecline",
  ApprovalDelete = "ApprovalDelete",
  WorkflowFailed = "WorkflowFailed",
  WorkflowCreate = "WorkflowCreate",
  WorkflowPlay = "WorkflowPlay",
  WorkflowRetry = "WorkflowRetry",
  WorkflowAbort = "WorkflowAbort",
  WorkflowDelete = "WorkflowDelete",
  WorkflowUpdate = "WorkflowUpdate",
  WorkflowCompleted = "WorkflowCompleted",
  JobCompleted = "JobCompleted",
  JobFailed = "JobFailed",
  JobCancel = "JobCancel",
  JobAbort = "JobAbort",
  UserCreate = "UserCreate",
  UserModify = "UserModify",
  UserDelete = "UserDelete",
  UserDisable = "UserDisable",
  GroupCreate = "GroupCreate",
  GroupModify = "GroupModify",
  GroupDelete = "GroupDelete",
  ConfigIngestPackCreate = "ConfigIngestPackCreate",
  ConfigIngestPackModify = "ConfigIngestPackModify",
  ConfigIngestPlaceholderDelete = "ConfigIngestPlaceholderDelete",
  ConfigIngestPlaceholderCreate = "ConfigIngestPlaceholderCreate",
  ConfigIngestPlaceholderModify = "ConfigIngestPlaceholderModify",
  ConfigIngestPackDelete = "ConfigIngestPackDelete",
  ConfigCustomerCreate = "ConfigCustomerCreate",
  ConfigCustomerModify = "ConfigCustomerModify",
  ConfigCustomerDelete = "ConfigCustomerDelete",
}
